import React from 'react';
import CouponsRedeemedIconSvg from '../../../../../../assets/icons/coupons-redeemed-icon.svg';

export const CouponsRedeemedIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <img
            src={CouponsRedeemedIconSvg}
            alt="Coupons Redeemed"
            className={className}
        />
    );
};
